"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _QuizHelper = _interopRequireDefault(require("../QuizHelper"));

var _GamestatusService = _interopRequireDefault(require("../GamestatusService2"));

// import HighscoreService from '../HighscoreService';
var GameObject = /*#__PURE__*/function () {
  function GameObject() {
    (0, _classCallCheck2["default"])(this, GameObject);
    this.currentSetId = null;
    this.sets = {};
    this.status = _GamestatusService["default"].getGameStatuses().OPEN; // this.highscore = HighscoreService.getGameHighscore();
  } // getHighscore() {
  //   this.highscore = HighscoreService.getGameHighscore();
  //   this.sortHighscore();
  //   return this.highscore;
  // }
  //
  // sortHighscore() {
  //   this.highscore.sort((a, b)=> {
  //     if (a.credits === b.credits) {
  //       return 0;
  //     }
  //     if (a.credits > b.credits) {
  //       return -1;
  //     }
  //     return 1;
  //   });
  //
  //   let rank = 0;
  //   let ranksToSkip = 0;
  //   let lastCredits = null;
  //   const results = [];
  //   Object.values(this.highscore).forEach(score => {
  //     if ( typeof(score.credits) == 'undefined' || score.credits == null ) {
  //         throw new Error('something expected is not defined');
  //     }
  //     if (score.credits !== lastCredits) {
  //       rank += 1 + ranksToSkip;
  //       ranksToSkip = 0;
  //     } else {
  //       ranksToSkip += 1;
  //     }
  //     score.rank = rank;
  //     results.push(lastCredits = score.credits);
  //   });
  //  }


  (0, _createClass2["default"])(GameObject, [{
    key: "getQuestion",
    value: function getQuestion(setId) {
      return this.sets[setId];
    }
  }, {
    key: "getCurrentQuestionSet",
    value: function getCurrentQuestionSet() {
      return this.sets[this.currentSetId];
    }
  }, {
    key: "updateGameHighscoreWithLevelHighScore",
    value: function updateGameHighscoreWithLevelHighScore() {
      var currentLevelHighscore;

      if (this.getCurrentQuestionSet()) {
        currentLevelHighscore = this.getCurrentQuestionSet().getHighscore();
      } else {
        currentLevelHighscore = [];
      }

      var currentGameHighscore = _QuizHelper["default"].clone(this.highscore);

      var numberOfPlayersWithPointsInLevel = 0; // TODO: check if currentLevelHighscore is an array on which forEach can be applied.

      (0, _values["default"])(currentLevelHighscore).forEach(function (levelRanking) {
        if (!levelRanking.points) {
          throw new Error('something expected is not defined');
        }

        if (levelRanking.points > 0) {
          numberOfPlayersWithPointsInLevel += 1;
        }
      }); // TODO: check if currentLevelHighscore is an array on which forEach can be applied.

      (0, _values["default"])(currentLevelHighscore).forEach(function (levelRanking) {
        if (!levelRanking.userName || !levelRanking.name) {
          throw new Error('something expected is not defined');
        }

        var ranking; // for (const gameRanking of currentGameHighscore) {

        currentGameHighscore.forEach(function (gameRanking) {
          if (levelRanking.userName === gameRanking.userName) {
            ranking = gameRanking;
          }
        });

        if (!ranking) {
          ranking = {
            name: levelRanking.name,
            credits: 0,
            userName: levelRanking.userName
          };
          currentGameHighscore.push(ranking);
        }

        var creditsToAdd;

        if (numberOfPlayersWithPointsInLevel === 1) {
          if (levelRanking.points === 0) {
            creditsToAdd = 0;
          } else {
            creditsToAdd = 100;
          }
        } else if (levelRanking.points === 0) {
          creditsToAdd = 0;
        } else {
          creditsToAdd = Math.round((100 - 1) / (numberOfPlayersWithPointsInLevel - 1) * (numberOfPlayersWithPointsInLevel - levelRanking.rank) + 1);
        }

        ranking.credits += creditsToAdd;
      });
      this.highscore = currentGameHighscore;
      return this.highscore;
    }
  }]);
  return GameObject;
}();

exports["default"] = GameObject;